module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/apple-pay-payment-card-a0295f837a79d5d6330512145f6b6d81.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/apple-pay-payment-card.svg
// module id = w3Ba
// module chunks = 24